import ShareAsHighlightModal from './ShareAsHighlightModal';

export default ShareAsHighlightModal;
